var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { convertBuiltCampaignComponentResponseToBuiltComponentResponse } from "../../../shared/convert/convertBuiltCampaignComponentResponseToBuiltComponentResponse";
import { toPromise } from "src/shared/api/promise";
import { campaignChangeEvent } from "src/shared/store/event-bus/campaign";
function handleError() {
    // Intentionally ignore errors during campaign loading
}
const notifyDeprecatedEventBus = (campaignId) => {
    campaignChangeEvent.emit({
        campaignId,
    });
};
export function loadAndEmitCampaignState(parameters) {
    return __awaiter(this, void 0, void 0, function* () {
        // TODO - Remove when things are fully migrated to the new event bus
        notifyDeprecatedEventBus(parameters.campaignId);
        const builtCampaignPromise = toPromise(parameters.campaignEndpoints.getBuiltCampaign(parameters.campaignId));
        const campaignSummaryPromise = parameters.campaignSummaryEndpoints.getCampaignSummary(parameters.campaignId);
        builtCampaignPromise
            .then((builtCampaign) => {
            parameters.inboundEventBus.emit("built_campaign_updated", {
                builtCampaign,
            });
            builtCampaign.components.forEach((component) => {
                parameters.inboundEventBus.emit("built_component_updated", {
                    builtComponent: convertBuiltCampaignComponentResponseToBuiltComponentResponse({
                        campaignId: parameters.campaignId,
                        campaignState: builtCampaign.state,
                        sourceClientId: parameters.sourceClientId,
                        builtCampaignComponent: component,
                    }),
                });
            });
        })
            .catch(handleError);
        campaignSummaryPromise
            .then((campaignSummary) => {
            parameters.inboundEventBus.emit("campaign_summary_updated", {
                campaignSummary,
            });
        })
            .catch(handleError);
        yield Promise.all([builtCampaignPromise, campaignSummaryPromise]);
    });
}
